export default "__VITE_ASSET__255ba404__"